import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { App, Button, Popconfirm, Popover, Space } from 'antd';
import React, { useState } from 'react';
import { queryKeys } from '../../services/react-query/queryKeys';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { ModalAppComplaint } from '../../components/upeosoft/ModalApp/ModalApp';
import { PlusOutlined } from '@ant-design/icons';
import { deleteComplaint, getComplaint } from '../../network/complaint';

const Complaint = ({ t }) => {
  const client = useQueryClient();
  const [searchText, setSearchText] = useState('');
  const [editId, setEditId] = useState('');
  const [edit, setEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const { message } = App.useApp();
  const handleRemove = useMutation(
    // (id) => deletePatient(id),
    {
      mutationFn: (id) => deleteComplaint(id),
      onSuccess: (data) => {
        console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(data?.message ? data?.message : 'Deleted successfully');
        client.invalidateQueries({ queryKey: [queryKeys.getComplaint] });
      },
      onError: () => {
        message.error('Something went wrong');
      },
    }
  );
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getComplaint],
    queryFn: () => getComplaint(),
    keepPreviousData: true,
  });
  const columns = [
    {
      title: t.complaint,
      dataIndex: 'name',
      key: 'name',
      filteredValue: [searchText],
      onFilter: (value, record) => {
        const name = String(record.name).toLowerCase();
        const searchValue = value.toLowerCase();
        // console.log(record);
        return name.includes(searchValue);
      },
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      width: 200,
      render: (text, record) => {
        return (
          <Space>
            {/* <ModalAppServices t={t} edit={true} /> */}
            <Popover
              placement="top"
              title={t.edit}
              onClick={() => {
                setEditId(record?.name);
                setOpen(true);
                setEdit(true);
              }}
            >
              <Button size="small" type="primary">
                <MdModeEditOutline />
              </Button>
            </Popover>
            <Popconfirm
              title={t.DeletetheMaterial}
              description={t.areYouSure}
              onConfirm={() => handleRemove.mutate(record?.name)}
              // onCancel={cancel}
              okText={t.yes}
              cancelText={t.no}
            >
              <Button size="small" type="primary" danger>
                <MdDelete />
              </Button>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => {
    // console.log('item:', item);
    return {
      key: index,
      ...item,
    };
  });
  // if (isError) {
  //   console.log('error:', error);
  //   return message.error(error.message);
  // }
  return (
    <div className="inventory">
      <Heading title={t.settings} subTitle={t.complaint} path="/" />
      <DynamicTableAnt
        columns={columns}
        data={dataTable}
        loading={isLoading}
        setSearchText={setSearchText}
        // titleBtn="Add Material"
        Placeholder={t.searchMaterialName}
        // pathBtn="/inventory/add"
        buttonModal={
          <Button
            type="primary"
            onClick={() => {
              setOpen(true);
              setEdit(false);
            }}
          >
            <PlusOutlined
              style={{
                fontSize: '10px',
              }}
            />{' '}
            {t.AddComplaint}
          </Button>
        }
      />
      <ModalAppComplaint
        t={t}
        edit={edit}
        record={editId}
        open={open}
        setOpen={setOpen}
      />
    </div>
  );
};

export default Complaint;
